import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
/* eslint-disable */
export var toUpperCase = function toUpperCase(str) {
  if (str[0]) {
    return str.replace(str[0], str[0].toUpperCase());
  } else {
    return "";
  }
};
export var toLowerCase = function toLowerCase(str) {
  if (str[0]) {
    return str.replace(str[0], str[0].toLowerCase());
  } else {
    return "";
  }
};

// 驼峰转换下划线
export var toSQLLine = function toSQLLine(str) {
  if (str == "ID") return "ID";
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
};

// 下划线转换驼峰
export var toHump = function toHump(name) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase();
  });
};

//下载csv文件，循环searchInfo的值(1)
// export const toGetSearch = (data) => {
//     var _result = [];
//     for (var key in data) {

//         var value = data[key];

//         if (value.constructor === Object) {

//             for (var key in value) {
//                 var context = value[key];
//                 //server_id里有0就不传server_id
//                 if (context.constructor == Array) {
//                     if (key == "server_id") {
//                         if (context.indexOf("0") == -1) {
//                             _result.push(key + "=" + '[' + context + ']')
//                         }
//                     } else {
//                         _result.push(key + "=" + '[' + context + ']')
//                     }
//                 } else {
//                     _result.push(key + '=' + context);
//                 }
//             }
//         } else {
//             _result.push(key + '=' + value);
//         }
//     }
//     return _result.join('&');
// }

//下载csv文件，循环searchInfo的值(2)
export var toGetSearch = function toGetSearch(data) {
  var _result = [];
  for (var key in data) {
    var value = data[key];
    if (value.constructor === Object) {
      for (var key in value) {
        var context = value[key];
        if (context.constructor == Array) {
          if (context && context.length && context[0].constructor == String) {
            var str = '"' + context.join('","') + '"';
            _result.push(key + "=" + '[' + str + ']');
          } else if (context && context.length && context[0].constructor == Number) {
            _result.push(key + "=" + '[' + context + ']');
          }
        } else {
          _result.push(key + '=' + context);
        }
      }
    } else {
      _result.push(key + '=' + value);
    }
  }
  return _result.join('&');
};